export default "__VITE_ASSET__DcK3ogZy__"